// extracted by mini-css-extract-plugin
export var labelPadding = "index-module--labelPadding--2p1wb";
export var labelText = "index-module--labelText--3u0Yv";
export var container = "index-module--container--1ifcm";